import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import { CmsSimpleResponsiveBannerComponent } from '@promo/const';
import { tabletImageGenerator } from '@promo/utils';
import { DeviceService } from '@shared/services';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, fromEvent } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'sd-substrate-responsive-banner',
  templateUrl: './substrate-responsive-banner.component.html',
  styleUrls: ['./substrate-responsive-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdSubstrateResponsiveBannerComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  banner$: Observable<CmsSimpleResponsiveBannerComponent>;
  isTablet$: Observable<boolean>;
  isScrolledDown$: Observable<boolean>;

  constructor(
    private component: CmsComponentData<CmsSimpleResponsiveBannerComponent>,
    private deviceService: DeviceService,
    private elRef: ViewContainerRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    const STICKY_HEADER_HEIGHT = 50;

    this.banner$ = this.component.data$.pipe(
      filter<CmsSimpleResponsiveBannerComponent>(Boolean),
      map(tabletImageGenerator),
    );

    this.isTablet$ = this.deviceService.isTabletMdDown$.pipe(distinctUntilChanged());

    this.isScrolledDown$ = fromEvent(this.document, 'scroll').pipe(
      map(
        () => this.document.defaultView.scrollY > this.elRef.element.nativeElement.offsetHeight - STICKY_HEADER_HEIGHT,
      ),
      startWith(false),
      distinctUntilChanged(),
    );

    this.initialize();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.removeTransparent();
  }

  private initialize(): void {
    this.subscription.add(
      combineLatest([this.isTablet$, this.isScrolledDown$]).subscribe(([isMobile, isScrolledDown]) => {
        if (isMobile && isScrolledDown) {
          this.removeTransparent();
        } else {
          this.addTransparent();
        }
      }),
    );
  }

  private addTransparent(): void {
    this.renderer.addClass(this.document.body, 'transparent-header');
  }

  private removeTransparent(): void {
    this.renderer.removeClass(this.document.body, 'transparent-header');
  }
}
